var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM15.5167 27.7084C15.9788 27.7084 16.1899 27.5028 16.4452 27.2543L16.4667 27.2334L18.749 25.0141L23.4972 28.5221C24.3709 29.0042 25.0015 28.7546 25.2192 27.7109L28.336 13.0234C28.6551 11.744 27.8483 11.1638 27.0124 11.5432L8.71066 18.6003C7.4614 19.1014 7.46868 19.7984 8.48295 20.1089L13.1796 21.5748L24.0528 14.715C24.5661 14.4038 25.0372 14.5711 24.6506 14.9143L15.8404 22.8647L15.84 22.8645L15.5167 27.7084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.1b5ebf979fdccf67bc119ca99fac11db.svg";
export { ForwardRef as ReactComponent };